module.exports = __webpack_public_path__ + "static/media/shop-online-card.ab36f3ac.png";